import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {SimulationAreaResult, SimulationAreaResultClass} from '../state/simulation.model';

@Component({
  selector: 'app-simulation-area-result',
  templateUrl: './simulation-area-result.component.html',
  styleUrls: ['./simulation-area-result.component.scss']
})
export class SimulationAreaResultComponent implements OnInit {

  totals: SimulationAreaResultClass;

  constructor(
    @Inject(MAT_DIALOG_DATA) public result: SimulationAreaResult
  ) { }

  ngOnInit(): void {
    this.totals = {
      collective_nres_abs: this.result.classes.map(c => c.collective_nres_abs).reduce((a,b) => a + b),
      collective_nres_rel: this.result.classes.map(c => c.collective_nres_rel).reduce((a,b) => a + b),
      collective_res_abs: this.result.classes.map(c => c.collective_res_abs).reduce((a,b) => a + b),
      collective_res_rel: this.result.classes.map(c => c.collective_res_rel).reduce((a,b) => a + b),
      economic_class: '',
      individual_nres_abs: this.result.classes.map(c => c.individual_nres_abs).reduce((a,b) => a + b),
      individual_nres_rel: this.result.classes.map(c => c.individual_nres_rel).reduce((a,b) => a + b),
      individual_res_abs: this.result.classes.map(c => c.individual_res_abs).reduce((a,b) => a + b),
      individual_res_rel: this.result.classes.map(c => c.individual_res_rel).reduce((a,b) => a + b)
    };
  }

}
